var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRetrieveLeague, useUpdateLeague } from "../api/LeagueApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { LeagueForm } from "./LeagueForm";
export var UpdateLeague = function () {
    var id = useNumericParams().id;
    var navigate = useNavigate();
    var _a = useRetrieveLeague({ id: id }), league = _a.data, isLeagueLoading = _a.isLoading, leagueError = _a.error;
    var _b = __read(useState(false), 2), loading = _b[0], setLoading = _b[1];
    var mutation = useUpdateLeague({
        id: id,
        onMutate: function () { return setLoading(true); },
        onSuccess: function (data) {
            var league = data.data;
            navigate("/leagues/".concat(league.id, "/"));
        },
        onError: function (error) {
            setLoading(false);
            console.error(error);
        },
    });
    var handleSubmit = function (data) {
        mutation.mutate(data);
    };
    if (isLeagueLoading || loading) {
        return _jsx(Loading, {});
    }
    if (leagueError || !league) {
        return _jsx(ErrorView, { error: leagueError });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update league. Please try again.", onClose: function () { } }), _jsx(Typography, { variant: "h6", gutterBottom: true, children: _jsxs("strong", { children: ["Update ", league.name] }) }), _jsx(LeagueForm, { league: league, onSubmit: handleSubmit })] }));
};
